import { Component, computed, inject } from '@angular/core';
import { CorporateGroupFilterDto, CorporateGroupItemDto, CorporateGroupService } from '@artemis-software/wr-api';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { CurrentUserService } from '@services/current-user.service';

@Component({
  standalone: false,
  selector: 'wr-corporate-group-overview-page',
  templateUrl: './corporate-group-overview-page.component.html',
  styleUrls: ['./corporate-group-overview-page.component.scss'],
})
export class CorporateGroupOverviewPageComponent {
  private readonly corporateGroupService = inject(CorporateGroupService);
  private readonly currentUserService = inject(CurrentUserService);
  private readonly router = inject(Router);
  private readonly formBuilder = inject(FormBuilder);

  readonly canManage = computed(() => this.currentUserService.hasPrivilege('viewCorporateGroup'));

  readonly loadGroups = (filter: CorporateGroupFilterDto) => this.corporateGroupService.findAll(filter);
  readonly getCount = (filter: CorporateGroupFilterDto) => this.corporateGroupService.getCount(filter);

  readonly form: FormGroup = this.formBuilder.group({
    text: this.formBuilder.control(''),
  });

  navigateTo(item: CorporateGroupItemDto): void {
    this.router.navigate(['corporate-group', item.id]);
  }

  add(): void {
    this.router.navigate(['corporate-group', 'new']);
  }
}
